var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.498871 6.78874C0.108347 7.17927 0.108347 7.81243 0.498871 8.20296L6.86283 14.5669C7.25336 14.9574 7.88652 14.9574 8.27705 14.5669C8.66757 14.1764 8.66757 13.5432 8.27705 13.1527L2.62019 7.49585L8.27705 1.839C8.66757 1.44847 8.66757 0.815306 8.27705 0.424782C7.88652 0.0342574 7.25336 0.0342574 6.86283 0.424782L0.498871 6.78874ZM19.3 6.49585L1.20598 6.49585V8.49585L19.3 8.49585V6.49585Z",
    fill: "#007FA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.32dbf9228020c6a382a456de1fffe4ba.svg";
export { ForwardRef as ReactComponent };